// extracted by mini-css-extract-plugin
export default {"button":"BorderedButton_button__7b0NT"};